import * as React from "react";
import { getFunctionHandler } from "../../../../constants";
import { EarlyExitBadge } from "../EarlyExitBadge";
const mapTags = new Proxy({
    earlyExit: EarlyExitBadge,
}, getFunctionHandler);
export const Tag = React.memo(function Tag(props) {
    const { tag, testId, variant } = props;
    const TagComponent = mapTags[tag.type];
    return React.createElement(TagComponent, { label: tag.label, messages: tag.messages || [], isActive: tag.isActive === undefined ? true : tag.isActive, testId: testId, variant: variant });
});
//# sourceMappingURL=Tag.js.map